import React from 'react'
import injectSheet from 'react-jss'
import { ContentContainer } from '../../'

const TitleContainer = (props) => {
  const {
    children,
    classes,
    title,
    subTitle,
  } = props

  return (
    <ContentContainer>
      <div className={`${classes.nodeHeaderContainer}`}>
        <h2 className={`${classes.nodeTitle}`}>
          {title}
        </h2>
        {subTitle && (
          <h5 className={`${classes.nodeSubTitle}`}>
            {subTitle}
          </h5>
        )}
      </div>
      {children}
    </ContentContainer>
  )
}

const styles = theme => ({
  nodeHeaderContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: `0 ${theme.sizes.gutter / 2}px`,
  },
  nodeTitle: {
    color: theme.colors.main_3,
    '& .button': {
      '&:hover': {
        color: theme.colors.secondary_3b,
      },
    },
  },
  nodeSubTitle: {
    margin: 0,
    color: theme.colors.main_3,
    width: '100%',
  },
})

export default injectSheet(styles)(TitleContainer)



// WEBPACK FOOTER //
// ./src/modules/core/components/titleContainer.jsx